import {
  ODataHeader,
  ODataString,
  ODataInteger,
  ODataBoolean,
  ODataDate
} from "pbas-vue-components";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});

var SickHourBankSettingsHeaders =
   [
    new ODataHeader({
      type: new ODataString("Id"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      isIdentifier: true,
    }),
    new ODataHeader({
      type: new ODataString("PlanIdentityId"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.plan",
      type: new ODataString("PlanIdentity/UniqueIdentifier"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("MemberGroupIdentityId"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.effective_date",
      type: new ODataDate("EffectiveDate"),
      sortable: true,
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
     }),
    new ODataHeader({
      title: "headers.sick_payment_settings.maximum_accumulated_hours",
      type: new ODataInteger("MaximumAccumulatedHours"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
    new ODataHeader({
      title: "headers.sick_payment_settings.maximum_threshold",
      type: new ODataInteger("MaximumThreshold"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
    new ODataHeader({
      title: "headers.sick_payment_settings.sick_days_per_year",
      type: new ODataInteger("SickDaysPerYear"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
    new ODataHeader({
      title: "headers.sick_payment_settings.hours_per_sick_day",
      type: new ODataInteger("HoursPerSickDay"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
    new ODataHeader({
      title: "headers.sick_payment_settings.supports_half_days",
      type: new ODataBoolean("SupportsHalfDays"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
    new ODataHeader({
      title: "headers.sick_payment_settings.hours_to_deduct",
      type: new ODataInteger("HoursToDeduct"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
    new ODataHeader({
      title: "headers.sick_payment_settings.has_to_be_eligible",
      type: new ODataBoolean("HasToBeEligible"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
    new ODataHeader({
      title: "headers.sick_payment_settings.has_to_have_been_eligible",
      type: new ODataBoolean("HasToHaveBeenEligible"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
    new ODataHeader({
      title: "headers.sick_payment_settings.days_for_warning",
      type: new ODataInteger("DaysForWarning"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
  ];


export default SickHourBankSettingsHeaders;
